import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as routeBound from '../../route-bound'

import { Api } from './api.service'
import type { TypeParams } from './types'

/**
 * Entity collection for {@link ents.extra.rate.Allocation.Distribution.OfPool.Breakdown}
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: allocationDistribution => allocationDistribution.id,
      name: ec.Name.Predefined.RateAllocationDistribution,
    })
  }
}
